// src/utils/validators.js

// Common regexes
export const re = {
  PAN: /^[A-Z]{5}\d{4}[A-Z]$/,                               // ABCDE1234F
  GSTIN: /^\d{2}[A-Z]{5}\d{4}[A-Z][1-9A-Z]Z[0-9A-Z]$/,        // 15 chars; 14th is 'Z'
  AADHAAR: /^[2-9]\d{11}$/,                                   // 12 digits, starts 2-9
  MOBILE_PRIMARY: /^[6-9]\d{9}$/,                             // Indian 10-digit mobile
};

// Normalizers
export const digits = (v = "") => (v || "").replace(/\D/g, "");
export const normalizePAN = (v = "") =>
  (v || "").toUpperCase().replace(/[^A-Z0-9]/g, "").slice(0, 10);
export const normalizeGSTIN = (v = "") =>
  (v || "").toUpperCase().replace(/[^A-Z0-9]/g, "").slice(0, 15);

// Validators
export const validatePAN = (v) => re.PAN.test(normalizePAN(v || ""));
export const validateGSTIN = (v) => re.GSTIN.test(normalizeGSTIN(v || ""));
export const validateAadhaar = (v) => re.AADHAAR.test(digits(v || ""));
export const validatePrimaryPhone = (v) => re.MOBILE_PRIMARY.test(digits(v || ""));
export const validateSecondaryPhone = (v) => {
  const d = digits(v || "");
  if (!d) return true; // optional field: empty is OK
  return re.MOBILE_PRIMARY.test(d);
};
